import { render, staticRenderFns } from "./AddSVDLocationMapping.vue?vue&type=template&id=289c200c&"
import script from "./AddSVDLocationMapping.vue?vue&type=script&lang=js&"
export * from "./AddSVDLocationMapping.vue?vue&type=script&lang=js&"
import style0 from "./AddSVDLocationMapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports